import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { RadioMultiCheckBoxStyled } from "./styled";
import { useTranslation } from "react-i18next";

const MultiCheckBox = ({
  theme_standard,
  theme_horizontal,
  theme_question,
  theme_bosendorfer,
  theme_purple,
  label,
  errors,
  disabled,
  disabledType,
  options,
  name,
  onChange,
  value = [], // ค่า default เป็น array
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_horizontal: theme_horizontal,
    theme_question: theme_question,
    theme_bosendorfer: theme_bosendorfer,
    theme_purple: theme_purple,
  });

  const { t } = useTranslation(["common"]);

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const checkValue = e.target.value;
    let updatedValue = [...value];

    if (e.target.checked) {
      // เพิ่มค่าที่เลือก
      updatedValue.push(checkValue);
    } else {
      // ลบค่าที่ยกเลิกการเลือก
      updatedValue = updatedValue.filter((v) => v !== checkValue);
    }

    // ส่งค่ากลับไปยัง parent
    onChange && onChange({ target: { name, value: updatedValue } });
  };

  // ตรวจสอบว่าค่านี้ถูกเลือกหรือไม่
  const isChecked = (optionValue) => {
    return Array.isArray(value) && value.includes(optionValue);
  };
  return (
    <RadioMultiCheckBoxStyled>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <div className="radio_row">
          {options &&
            options.map((e, i) => (
              <div
                key={i}
                className={`radio_item ${isChecked(e.value) ? "checked" : ""}`}
                onClick={() => {
                  if (disabled) return;
                  handleCheckboxChange({
                    target: {
                      value: e.value,
                      checked: !isChecked(e.value),
                    },
                  });
                }}
              >
                <span className="custom_radio" />
                <span className="custom_label">{e.label}</span>
              </div>
            ))}
        </div>
        {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
      </div>
    </RadioMultiCheckBoxStyled>
  );
};

MultiCheckBox.propTypes = {};

export default MultiCheckBox;
